import { helpers } from '@vuelidate/validators';

const decimalRegex = /^[-]?\d*([\\.,]\d+)?$/;

const validator = helpers.regex(decimalRegex);

export default validator;
